module.exports = __webpack_public_path__ + "img/img4zhounq-3.0c666742.png";